/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TarfResubmitRequestBody = {
    properties: {
        status: {
    type: 'number',
    isRequired: true,
},
    },
};